<script>
import appConfig from "./dados/app.config.json";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  },
};
</script>
<style>
.form-control:disabled, .form-control[readonly] {
  background-color: #f6f6f9;
  opacity: 1;
}

input[type="text"][disabled] {
  background-color: #f6f6f9;
}

select option:disabled {
  background-color: #f6f6f9;
}

.option__title {
  word-wrap: break-word;
  white-space: normal;
}

fieldset.div-group {
  margin: 0 0 1.4em 0 !important;
}

legend.div-group {
  font-size: 1em !important;
  font-weight: bold !important;
  text-align: left !important;
  width: auto;
  padding: 0 10px;
  border-bottom: none;
}

</style>

<template>
  <div id="app">
    <notifications position="bottom left"/>
    <RouterView/>
  </div>
</template>
